"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var MobileButton_1 = require("./MobileButton");
require("./styles.scss");
function MobileButtons(props) {
    return (React.createElement("div", { className: classNames('mobile-buttons', props.className) }, props.settings &&
        props.settings.map(function (data) {
            return (React.createElement(MobileButton_1.default, { key: data.localization, iconClassName: data.icon, localization: data.localization, onClick: data.onClick }));
        })));
}
exports.default = MobileButtons;
